<app-shared-engagement-table
  [engagementList]="engagementList"
  [loading]="loading"
  [prevDocumentType]="prevDocumentType"
  (refreshList)="
    initializeInvoiceDocReviewList()
  "></app-shared-engagement-table>
